module.exports = __webpack_public_path__ + "static/media/vivien-truong.e9c50860.jpg";